import { useContext, useState } from "react";
import Paragraph from "../../../elements/p/Paragraph";
import Button from "../../../elements/buttons/Button";
import ButtonAction from "../../../elements/buttons/ButtonAction";
import modalContext from "../../../../dataManager/context/modalContext";
import { deleteCategory } from "../../../../api/categories/categoriesApi";
import { toast } from "react-toastify";

const DeleteCategory = () => {
  //context section
  const { onClose, modalParams } = useContext(modalContext);

  //state variables
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  //some handler
  const handleDelete = async (id) => {
    //start loading
    setLoading(true);

    const { data, error } = await deleteCategory(id);

    if (error) {
      setError(error);
      return setLoading(false);
    }

    setLoading(false);
    onClose();
    toast.success("La catégorie à été supprimée avec succes !", {
      theme: "colored",
    });
  };

  return (
    <div className="w-full">
      <Paragraph>
        En suppriment cette catégorie de produit, vous supprimez également tous
        les produit liés à celle ci. voulez-vous continuer ?
      </Paragraph>
      <div className="mt-4 flex items-center">
        <ButtonAction
          size="small"
          loading={loading}
          onClick={() => handleDelete(modalParams.categoryId)}
        >
          Supprimer
        </ButtonAction>
        <ButtonAction size="small" type="secondary" onClick={onClose}>
          Anuler
        </ButtonAction>
      </div>

      <span className="mt-1 font-nunito text-sm text-[#fc3838]">
        {error && error}
      </span>
    </div>
  );
};

export default DeleteCategory;
